export default __webpack_public_path__ + "static/media/img-get-premium.6f79ee4a.png";